<template>
  <div>
    <div>
      <div
        class="headline p-md-5 d-flex align-items-end"
        :style="'background: linear-gradient(0.52deg, rgba(33, 37, 43, 0.53) 14.72%, rgba(33, 37, 43, 0) 168.66%), url(/news/custom-banner.jpg) center/cover'"
      >
        <div class="text pb-4 pb-md-3 pt-5 px-3 px-md-5">
          <div class="category">Цікаво знати</div>
          <h1 class="m-0">
            Як профінансувати своє житло у черзі Bory Nádvorie?
          </h1>
        </div>
      </div>
      <div class="news m-auto py-4 py-md-5 custom-article">
        <div class="news-wrapper detail">
          <div class="article-container">
            <p class="mb-5 strong">
              Шлях до будинку вашої мрії не повинен бути cкладним. <br>Ми познайомимо вас з можливостями і процесом фінансування вашої нової нерухомості в рамках нашого проєкту Bory&nbsp;Nádvorie.
            </p>
            <h3 class="text-center">
              Процес фінансування у проєкті Bory&nbsp;Nádvorie до введення будинку в експлуатацію складається з 8 чітких кроків
            </h3>
            <div class="timeline">
              <div class="step step-1">
                <div class="num">1</div>
                <div class="desc">
                  <p class="strong">
                    Виберіть потрібну Вам квартиру.
                  </p>
                </div>
              </div>
              <div class="step step-2">
                <div class="num">2</div>
                <div class="desc">
                  <p class="strong">
                    Ви звертаєтеся до нашого продавця, який проконсультує Вас щодо вибору квартири, а після підготовки договору зв’яже вас з фахівцем з іпотечного кредитування.
                  </p>
                </div>
              </div>
              <div class="step step-3">
                <div class="num">3</div>
                <div class="desc">
                  <p class="strong">
                    Наш фахівець з іпотечних кредитів організує індивідуальну зустріч з Вами та підготує найбільш вигідні фінансові пропозиції протягом 24 годин після зустрічі.
                  </p>
                </div>
              </div>
              <div class="step step-4">
                <div class="num">4</div>
                <div class="desc">
                  <p class="strong">
                    Фахівець з іпотечних кредитів підготує заявку на отримання іпотечного кредиту в обраному Вами банку/банках і буде вести всю необхідну комунікацію та забезпечить документообіг з банком від Вашого імені.
                  </p>
                  <div class="highlight">
                    З нами Вам не загрожують інфляційні ризики<br /><a
                      href="/novinky/na-co-si-dat-pozor-pri-kupe-bytu-v-novostavbe"
                      >Дізнатися більше</a
                    >
                  </div>
                </div>
              </div>
              <div class="step step-5">
                <div class="num">5</div>
                <div class="desc">
                  <p class="strong">Підписання попереднього договору</p>
                  <p class="light">
                    Ви підписуєте попередній договір і сплачуєте першу частину від вартості покупки в розмірі 10% двома платежами.
                  </p>
                </div>
              </div>
              <div class="step step-6">
                <div class="num">6</div>
                <div class="desc">
                  <p class="strong">Ви вносите перший платіж у розмірі 5 000,00 євро.</p>
                </div>
              </div>
              <div class="step step-7">
                <div class="num">7</div>
                <div class="desc">
                  <p class="strong">
                    Ви сплачуєте другий платіж у розмірі 10% від вартості покупки
                  </p>
                  <p class="light">
                    Ви можете використати для цього власні кошти або, в деяких ситуаціях, взяти кредит на перший внесок без застави квартири.<br> Це можливо лише в деяких банках. Після цього ви здійснюєте щомісячний платіж лише за використану частину кредиту. <br>Наш фахівець з іпотечного кредитування надасть Вам більш детальну інформацію.
                  </p>
                </div>
              </div>
              <div class="step step-7">
                <div class="num">8</div>
                <div class="desc">
                  <p class="strong">Рішення по іпотечному кредитуванню</p>
                  <p class="light">
                    З питань фінансування Ви можете звернутися до нашого фахівця з іпотечного кредитування. Після схвалення іпотечного кредиту кошти будуть зараховані лише в часі введення будинку до експлуатації, коли Вас попросять сплатити решту вартості покупки.
                  </p>
                </div>
              </div>
              <div class="step step-8">
                <div class="num">9</div>
                <div class="desc">
                  <p class="strong">
                    Після отримання дозволу про придатність будинку до експлуатації Ви сплачуєте решту 90% від вартості покупки.
                  </p>
                  <p class="light">
                    Ця частина може фінансуватися за рахунок власних коштів, за рахунок поєднання власних коштів та іпотеки або повністю за рахунок іпотечного кредиту. <br /><br />Наш фахівець з іпотечного кредитування перевірить зміст іпотечного договору та підготує всі інші необхідні документи (попередній договір для банку, страхування предмету застави, копію страхового договору, рахунок-фактуру...).  З цього моменту Ви будете здійснювати повний щомісячний платіж
                  </p>
                </div>
              </div>
            </div>
            <h3 class="text-center">
              Процес фінансування завершених проєктів
            </h3>
            <p class="mb-5">
              Якщо Ви зацікавлені у покупці квартири, в будинку, який вже було введено в експлуатацію, процес фінансування відрізнятиметься. Ознайомитися з його особливостями можна
              <a href="./ako-financovat-vase-byvanie-na-boroch" target="_blank"
                >тут</a
              >.
            </p>
          </div>
          <div class="full-banner">
            <div class="image"><img src="/news/custom-full-banner.jpg" /></div>
            <div class="text">
              <h2>Перегляньте актуальну пропозицію квартир</h2>
              <a href="/byty" class="btn">Переглянути пропозицію</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ContactForm></ContactForm>
  </div>
</template>

<script>
import ContactForm from "@/components/shared/ContactForm";

export default {
  name: "UaFinancovanieNadvorie",
  components: { ContactForm },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="sass" scoped>
$md: 768px
.full-banner
  margin-bottom: 0 !important
.news-wrapper.detail h2
  font-size: 40px
  line-height: 44px
  font-weight: bold
h1
  font-size: 64px
  line-height: 60px
  letter-spacing: -3px
  font-weight: 900
  max-width: 980px
  @media (max-width: $md)
    max-width: 100%
    font-size: 44px
    line-height: 44px
    letter-spacing: -2px
.category
  font-size: 28px
  line-height: 32px
  letter-spacing: -0.5px
  margin-bottom: 30px
  @media (max-width: $md)
    font-size: 18px
    line-height: 22px
    margin-bottom: 15px
.headline
  height: 550px
  background-size: cover
  background-position: center
  @media (max-width: $md)
    height: 70vh
.news
  max-width: 680px
  color: var(--darkBlue)
  @media (max-width: $md)
    max-width: 100%
    padding: 0 16px
  p, h2
    color: var(--darkBlue)
  h2
    font-size: 28px
    line-height: 32px
    letter-spacing: -0.5px
    margin-bottom: 25px
    font-weight: 400
  p
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 18px
      line-height: 22px
      font-weight: 400
  .figure
    margin: 50px 0
  .figure-caption
    color: var(--grey)
    font-size: 15px
    line-height: 23px
    margin-top: 5px
</style>
